
import 'polyfills';

import ReactOnRails from 'react-on-rails';

import FeatureFlagAlert from "../components/FeatureFlag/FeatureFlagAlert";
import Switcher from "../components/location/Switcher";
import CrossingLocale from '../components/location/CrossingLocale';
import View from "../components/Builder/View";

import warrantyTransferStore from '../components/Warranty/WarrantyTransferForm/redux/store'
import WarrantyTransferForm from "../components/Warranty/WarrantyTransferForm/warranty-transfer-form.jsx";
import Footer from "../components/OC/footer"
import Text from '../components/OC/oc-text';

ReactOnRails.registerStore({
  warrantyTransferStore
});

ReactOnRails.register({
  'WarrantyTransferForm': WarrantyTransferForm,
  'Location::Switcher': Switcher,
  'Location::Crossinglocale': CrossingLocale,
  'FeatureFlag::Featureflagalert': FeatureFlagAlert,
  'Builder::View': View,
  'OC::Text': Text,
  'OC::Footer': Footer
});
